import { pageconfigurationsApi } from 'app/src/services/welfareportal'
import { useWebAppContext } from 'app/src/shared/hooks'
import jsonLogic from 'json-logic-js'
import { useCallback } from 'react'

export function useComponentRenderer() {
  const context = useWebAppContext()

  const jsonLogicApply = useCallback(
    (jsonLogicExpression: Record<string, unknown>) => jsonLogic.apply(jsonLogicExpression, context.userInfo.welfareCampaign),
    [context?.userInfo?.welfareCampaign],
  )

  const getPage = useCallback(
    (pageCampaignItem?: pageconfigurationsApi.Page): pageconfigurationsApi.SectionItem[] => {
      if (!pageCampaignItem) return []

      let sections: pageconfigurationsApi.SectionItem[] =
        pageCampaignItem.find((x) => x.jsonLogicExpression && jsonLogicApply(x.jsonLogicExpression))?.sections ?? []

      if (sections && sections.length === 0) sections = pageCampaignItem.find((x) => !x.jsonLogicExpression)?.sections ?? []

      return sections?.filter((x) => !x.jsonLogicExpression || jsonLogicApply(x.jsonLogicExpression)) ?? []
    },
    [jsonLogicApply],
  )

  return { getPage }
}
